import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  API_ADD_GUEST_CART,
  API_CART_ADD,
  API_CART_GUEST_SUMMERY,
  API_CART_REMOVE,
  API_CART_SUMMERY,
  API_GET_CART,
  API_GET_GUEST_CART,
  API_MERGED_GUEST_CART,
  API_RECOMMENDED_COURSES_CART,
  API_REMOVE_GUEST_CART,
  Course,
  Pagination,
} from '../../models';
import { HttpQueryParams, HttpService } from '../http';
import { Add_Remove_Cart } from './cart.service';

export type CartItemsV2 = {
  id: number;
  items: CartItemsDataV2[];
};

export type CartItemsDataV2 = {
  id: string;
  course_id?: string;
  code?: string;
  title: string;
  subtitle: string;
  average_rating: number;
  slug: string;
  favorite: boolean;
  image_url: string;
  is_promote: boolean;
  language: string;
  total_rate: number;
  total_reviews: number;
  author?: string;
  priceDetails?: any;
};

export interface CartItemCategoryV2 {
  id: string;
  name: string;
  name_ar: string;
  slug: string;
}

export interface CartSummaryV2 {
  subtotal: number;
  final_total_amount: number;
  remaining_credit: number;
  currency: string;
  symbol: string;
  total_discount_amount: number;
  total_discount_percentage: number;
  tax_display_type: string;
  prices_include_tax: any;
  hide_zero_tax: any;
  total_tax_amount: number;
  payable_amount: number;
  credit_used: number;
  applied_coupon: [];
  tax_suffix: boolean;
}

export interface SummaryPayloadV2 {
  promo_code?: string;
  payables: Array<string | undefined>;
}
export interface CartPayload {
  product: string;
}

@Injectable({
  providedIn: 'root',
})
export class CommonCartServiceV2 {
  constructor(private readonly http: HttpService) {}

  addToCart(payload: CartPayload): Observable<Add_Remove_Cart> {
    return this.http.post<Add_Remove_Cart>(API_CART_ADD, payload);
  }

  removeToCart(payload: any): Observable<Add_Remove_Cart> {
    return this.http.post<Add_Remove_Cart>(API_CART_REMOVE, payload);
  }

  getCartItems(): Observable<CartItemsV2> {
    return this.http.get<CartItemsV2>(API_GET_CART);
  }

  // Guest cart
  addToGuestCart(payload: CartPayload, token: string): Observable<Add_Remove_Cart> {
    const options = { guestCartToken: token };
    return this.http.post<Add_Remove_Cart>(API_ADD_GUEST_CART, payload, undefined, options);
  }

  getGuestCartItems(token: string): Observable<CartItemsV2> {
    const options = { guestCartToken: token };
    return this.http.get<CartItemsV2>(API_GET_GUEST_CART, undefined, options);
  }

  mergedGuestCart(token: string): Observable<Add_Remove_Cart> {
    const options = { guestCartToken: token };
    return this.http.post<Add_Remove_Cart>(API_MERGED_GUEST_CART, {}, undefined, options);
  }

  removeToGuestCart(payload: CartPayload, token: string): Observable<Add_Remove_Cart> {
    const options = { guestCartToken: token };
    return this.http.post<Add_Remove_Cart>(API_REMOVE_GUEST_CART, payload, undefined, options);
  }

  recommendedCartItems(token: string, params = {} as HttpQueryParams): Observable<Pagination<Partial<Course>>> {
    const options = { guestCartToken: token };
    return this.http.get<Pagination<Partial<Course>>>(API_RECOMMENDED_COURSES_CART, params, options);
  }

  getCartSummary(payload: SummaryPayloadV2): Observable<CartSummaryV2> {
    return this.http.post<CartSummaryV2>(API_CART_SUMMERY, payload);
  }

  getGuestCartSummary(payload: SummaryPayloadV2, token: string): Observable<CartSummaryV2> {
    const options = { guestCartToken: token };
    return this.http.post<CartSummaryV2>(API_CART_GUEST_SUMMERY, payload, undefined, options);
  }
}
